import { h, defineComponent } from 'vue'
import FlagWrapperCell from './FlagWrapperCell.vue'
import { FlagIcon as LucideFlagIcon } from 'lucide-vue-next'
import FlagStatusCell from '@/Components/DataGrid/Cells/FlagStatusCell.vue'
import { FLAG_FILTER_VALUES } from '@/constants'

export const FlagIcon = LucideFlagIcon
export const FLAG_ICON_SIZE = 16

export const wrapWithFlag = (Component) => {
  return defineComponent({
    name: 'FlagWrapperProxy',
    props: ['params'],
    setup(props) {
      return () =>
        h(FlagWrapperCell, {
          params: props.params,
          wrappedComponent: Component
        })
    }
  })
}

export const createFlagColumn = ({ clientSideModel = false } = {}) => {
  const filterValues = clientSideModel
    ? FLAG_FILTER_VALUES.map((flag) => {
        return flag !== 'No Flags' ? flag : null
      })
    : FLAG_FILTER_VALUES

  const filterValueFormatter = clientSideModel
    ? (params) => {
        return params.value ? params.value : 'No Flags'
      }
    : null

  return {
    headerName: 'Flags',
    field: 'flags',
    cellRenderer: FlagStatusCell,
    sortable: false,
    filter: 'agSetColumnFilter',
    filterParams: {
      values: filterValues,
      valueFormatter: filterValueFormatter,
      suppressMiniFilter: true,
      suppressSorting: true
    }
  }
}
